<template>
    <div :class="['alert', `alert-${type}`]">
        <span :class="`icon fal ${icon}`"></span>
        <div class="title h6" v-if="$slots.title">
            <slot name="title" />
        </div>
        <div class="body xsmall">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'info',
        },
    },
    computed: {
        icon() {
            switch (this.type) {
                case 'success': {
                    return 'fa-check-circle';
                }

                case 'danger':
                case 'warning': {
                    return 'fa-exclamation-triangle';
                }

                default: {
                    return 'fa-exclamation-circle';
                }
            }
        },
    },
};
</script>
